<template>
    <div class="v4y-info-box py-2">
        <div class="mx-4 py-3 d-flex align-items-center whitespace-nowrap text-nowrap">
            <span class="ms-2 me-3">
                <info_icon_gelb></info_icon_gelb>
            </span>
            <b>Hinweis zur Bedeutung der Vergangenheitsklausel<template v-if="mainStore.produktName"> (gilt für <span v-html="mainStore.produktName"></span> Ein-/Zweibettzimmer)</template>:</b>
        </div>
        <div class="mx-4 mb-3">
            Krankheiten, die in den letzten 2 Jahren vor Versicherungsbeginn  bestanden und für die eine stationäre Behandlung in dieser Zeit bereits  eine Behandlungsoption darstellte, sind nicht Teil des  Versicherungsschutzes. Es gelten allgemeine Wartezeiten von 3 Monaten  und im Falle von Schwangerschaft, Psychotherapie und Zahnersatz von 8  Monaten Wartezeit. Die allgemeine Wartezeit entfällt bei einem Unfall.
            <br><br>
            Alle anderen Krankenhausaufenthalte sind versichert.
            
        </div>
        <div class="mx-4 mb-3 mt-4">
            <div>
                <b>Beispiele (jeweils bei Versicherungsbeginn: {{ nextMonthFirstDay }}):</b>
            </div>
            <div class="mt-3 d-flex flex-row">
                <span>
                    <kreuz_icon></kreuz_icon>
                </span>
                <div class="ms-3">
                    Nach einem Unfall im Jahr {{ previousYear }} wurde ein Bruch mit Schrauben fixiert, die  später entfernt werden müssen. Dies erfolgt am {{ futureDate }}. Es besteht  keine Leistungspflicht für diesen Eingriff, da in den letzten 2 Jahren  vor Vertragsabschluss bereits feststand, dass eine solche Operation  stattfinden muss.
                </div>
            </div>
            <div class="mt-3 d-flex flex-row">
                <span>
                    <haken_icon></haken_icon>
                </span>
                <div class="ms-3">
                    Zwei Jahre vor Vertragsbeginn lag ein Bruch des linken Sprunggelenks vor. Dieser heilte komplett aus. Während der Vertragslaufzeit erfolgt bei einem Spaziergang ein erneuter Bruch des linken Sprunggelenks. Da es sich um einen neuen Versicherungsfall handelt, ist dieser versichert.
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useMainStore } from '@/stores/useMainStore.js';
import info_icon_gelb from '@/components/icons/info_icon_gelb.vue';
import haken_icon from '@/components/icons/haken_icon.vue';
import kreuz_icon from '@/components/icons/kreuz_icon.vue';

const mainStore = useMainStore();

// Datums-Berechnungen
const nextMonthFirstDay = ref('');

const getDate = () => {
  const date = new Date();
  date.setDate(1); // Set date to 1st of current month
  date.setMonth(date.getMonth() + 1); // Move to next month
  nextMonthFirstDay.value = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const previousYear = ref('');

const getPreviousYear = () => {
  const date = new Date();
  previousYear.value = date.getFullYear() - 1;
};

const futureDate = ref('');

const getFutureDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 115); // Add 115 days
  futureDate.value = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const longtermDate = ref('');

const getLongtermDate = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 11); // Subtract 11 years
  longtermDate.value = date.getFullYear(); // Get only the year
};

const dateplus65 = ref('');

const getdateplus65 = () => {
  const date = new Date();
  date.setDate(date.getDate() + 65); // Add 65 days
  dateplus65.value = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const currentDate = ref('');

const getCurrentDate = () => {
  currentDate.value = new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// Initialize all date values
getDate();
getPreviousYear();
getFutureDate();
getLongtermDate();
getdateplus65();
getCurrentDate();
</script>